import {mergeSentry} from '@/shared/matrix';

mergeSentry({page: '홈&상세(home, detail)'});
